function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storeListApi, storeSaveApi, storeStatusApi, storeDeleteApi, storeLeaderOptionsApi } from '@/api/distributionStore';
import { fileImageApi } from '@/api/systemSetting';
var emptyForm = function emptyForm() {
  return {
    id: null,
    storeNo: '',
    storeName: '',
    contactName: '',
    contactPhone: '',
    address: '',
    leaderId: null,
    status: 0,
    remark: '',
    images: '',
    // images 在库里存 JSON 字符串，表单里用数组更好操作，提交时再序列化回去
    imageList: []
  };
};
var IMAGE_LIMIT = 6;

// 历史数据里 images 可能是 JSON 数组、单个地址，甚至是空串，统统兜住
function parseImages(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  try {
    var parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [String(parsed)];
  } catch (e) {
    return [raw];
  }
}
export default {
  name: 'DistributionStore',
  data: function data() {
    return {
      loading: false,
      saving: false,
      list: [],
      total: 0,
      query: {
        page: 1,
        limit: 20,
        keywords: '',
        status: null
      },
      dialogVisible: false,
      IMAGE_LIMIT: IMAGE_LIMIT,
      leaderList: [],
      leaderLoading: false,
      form: emptyForm(),
      rules: {
        storeName: [{
          required: true,
          message: '请输入门店名称',
          trigger: 'blur'
        }],
        contactPhone: [{
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.loadList(1);
  },
  methods: {
    loadList: function loadList(page) {
      var _this = this;
      if (page) this.query.page = page;
      this.loading = true;
      storeListApi(this.query).then(function (data) {
        _this.list = data.records || data.list || [];
        _this.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    parseImages: parseImages,
    coverOf: function coverOf(row) {
      return parseImages(row.images)[0] || '';
    },
    resetQuery: function resetQuery() {
      this.query = {
        page: 1,
        limit: 20,
        keywords: '',
        status: null
      };
      this.loadList(1);
    },
    openEdit: function openEdit(row) {
      var _this2 = this;
      this.form = row ? _objectSpread(_objectSpread({}, emptyForm()), row) : emptyForm();
      this.$set(this.form, 'imageList', parseImages(row && row.images));
      // 关联团长是远程搜出来的，编辑时下拉里得先有这一条，否则只显示一个光秃秃的 ID
      this.leaderList = row && Number(row.leaderId) > 0 ? [{
        id: row.leaderId,
        nickname: row.leaderName,
        phone: ''
      }] : [];
      if (!this.form.leaderId) this.form.leaderId = null;
      this.dialogVisible = true;
      this.$nextTick(function () {
        return _this2.$refs.form && _this2.$refs.form.clearValidate();
      });
      this.searchLeader('');
    },
    searchLeader: function searchLeader(keyword) {
      var _this3 = this;
      this.leaderLoading = true;
      storeLeaderOptionsApi({
        limit: 30,
        keywords: keyword || ''
      }).then(function (data) {
        var list = data || [];
        // 已选中的团长若不在搜索结果里，保留它，不然选中项会被清掉
        var picked = _this3.leaderList.find(function (it) {
          return it.id === _this3.form.leaderId;
        });
        _this3.leaderList = picked && !list.some(function (it) {
          return it.id === picked.id;
        }) ? [picked].concat(_toConsumableArray(list)) : list;
      }).finally(function () {
        _this3.leaderLoading = false;
      });
    },
    uploadImage: function uploadImage(param) {
      var _this4 = this;
      var formData = new FormData();
      formData.append('multipart', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading'
      });
      fileImageApi(formData, {
        model: 'store',
        pid: 0
      }).then(function (res) {
        _this4.form.imageList.push(res.url);
      }).catch(function () {}).finally(function () {
        return loading.close();
      });
    },
    removeImage: function removeImage(idx) {
      this.form.imageList.splice(idx, 1);
    },
    leaderLabel: function leaderLabel(item) {
      var name = item.nickname || '未命名';
      return item.phone ? "".concat(name, "\uFF08").concat(item.phone, "\uFF09") : name;
    },
    submit: function submit() {
      var _this5 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this5.saving = true;
        var payload = _objectSpread(_objectSpread({}, _this5.form), {}, {
          leaderId: _this5.form.leaderId || 0,
          images: _this5.form.imageList.length ? JSON.stringify(_this5.form.imageList) : ''
        });
        delete payload.imageList;
        storeSaveApi(payload).then(function () {
          _this5.$message.success('保存成功');
          _this5.dialogVisible = false;
          _this5.loadList();
        }).finally(function () {
          _this5.saving = false;
        });
      });
    },
    toggleStatus: function toggleStatus(row) {
      var _this6 = this;
      var next = row.status === 0 ? 1 : 0;
      storeStatusApi(row.id, next).then(function () {
        _this6.$message.success('操作成功');
        _this6.loadList();
      });
    },
    remove: function remove(row) {
      var _this7 = this;
      this.$confirm("\u786E\u5B9A\u5220\u9664\u95E8\u5E97\u300C".concat(row.storeName, "\u300D\u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(function () {
        return storeDeleteApi(row.id);
      }).then(function () {
        _this7.$message.success('删除成功');
        _this7.loadList();
      }).catch(function () {});
    }
  }
};